import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import {
	Frame,
	Arrow,
	Title,
	TitleUnderLine,
	TitleRow,
	DataDetail,
	Content,
	Data,
	DataTitle,
} from "./styles";
import { useAnimation } from "framer-motion";
import settings from "@src/settings";
import { useWindowSize } from "@src/utils/useWindowSize";

interface Props {
	title: string;
	data: {
		title: string;
		detail: string;
	}[];
	className?: string;
	defaultState?: "opened" | "closed";
}

const JobInfo: React.FC<Props> = (props) => {
	const { title, data, className, defaultState } = props;
	const selfRef = useRef<HTMLDivElement>(null);
	const { width: windowW } = useWindowSize();
	const [isOpened, setIsOpend] = useState(defaultState == "opened");
	const toggle = () => {
		if (window && isOpened && selfRef.current) {
			const selfPos = selfRef.current?.getBoundingClientRect();
			if (selfPos) {
				window.scrollTo({
					top: selfPos.y + window.scrollY - window.innerHeight / 2,
					behavior: "smooth",
				});
			}
		}
		setIsOpend(!isOpened);
	};
	const arrowControl = useAnimation();
	const lineControl = useAnimation();
	const dataControl = useAnimation();
	const contentControl = useAnimation();

	useEffect(() => {
		if (isOpened) {
			(async () => {
				arrowControl.start({
					transform: "rotate(0deg)",
					transition: {
						type: "spring",
						stiffness: 250,
						damping: 35,
						mass: 1,
					},
				});
				contentControl.set({
					padding:
						!window || window.innerWidth > settings.breakpoint.md ? 52 : 27,
				});
				await contentControl.start({
					height: "auto",
				});
				dataControl.start({
					opacity: 1,
					transition: {
						type: "linear",
						duration: 0.3,
					},
				});
				lineControl.start({
					opacity: 1,
				});
			})();
		} else {
			(async () => {
				arrowControl.start({
					transform: "rotate(180deg)",
					transition: {
						type: "spring",
						stiffness: 250,
						damping: 35,
						mass: 1,
					},
				});
				lineControl.start({
					opacity: 0,
				});
				await dataControl.start({
					opacity: 0,
				});
				await contentControl.start({
					height: 0,
					padding: 0,
				});
			})();
		}
	}, [isOpened]);

	return (
		<Frame onClick={toggle} className={className} ref={selfRef}>
			<TitleRow>
				<Title>{title}</Title>
				<Arrow animate={arrowControl}>
					{!windowW || windowW > settings.breakpoint.sm ? (
						<path
							d="M 3 15.178 L 13.339 4.839 L 23.678 15.178"
							fill="transparent"
							strokeWidth="6"
							stroke="rgb(26,48,129)"
							strokeMiterlimit="10"
						/>
					) : (
						<path
							d="M 3 15.178 L 13.339 4.839 L 23.678 15.178"
							fill="transparent"
							strokeWidth="6"
							stroke="rgb(26,48,129)"
							strokeMiterlimit="10"
						/>
					)}
				</Arrow>
				<TitleUnderLine animate={lineControl} />
			</TitleRow>
			<Content animate={contentControl}>
				{data &&
					data.map((val, index) => (
						<Data animate={dataControl} key={`jobData${index}`}>
							<DataTitle>{val.title}</DataTitle>
							<DataDetail>{val.detail}</DataDetail>
						</Data>
					))}
			</Content>
		</Frame>
	);
};

export default styled(JobInfo)``;
